import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { usePageConfig } from '../contexts/PageConfigContext';
import UserProfile from '../components/auth/UserProfile';
import './Profile.css';

const Profile = () => {
  const { isAuthenticated } = useAuth();
  const pageConfig = usePageConfig();
  const canEditName = pageConfig?.configuration?.can_edit_name === true;
  const canUpdatePassword = pageConfig?.configuration?.can_update_password === true;

  if (!isAuthenticated) {
    return (
      <div className="profile-page profile-page--centered">
        <div className="profile-card profile-card--message">
          <h2 className="profile-message-title">Sign in required</h2>
          <p className="profile-message-text">Sign in to view and edit your profile.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-page">
      <UserProfile canEditName={canEditName} canUpdatePassword={canUpdatePassword} />
    </div>
  );
};

export default Profile;
